﻿/**
 * Luzes do boneco em pé, geradas dos SWF do legado por `tools/extrair-luzes-equipamento.mjs` (ADR 0029). Cada luz é uma animação em loop de quadros
 * PNG já compostos (clipes aninhados, formas que se deformam, mistura e filtros). `originX` e `originY` dizem onde fica a origem do símbolo dentro do quadro.
 * `aura-arma` é o `CircleLightAsset` (atrás do boneco) e `luz-pes` é o `SinpleLightAsset` (nos pés).
 */
export interface EquipLightFrames {
  frames: number;
  width: number;
  height: number;
  originX: number;
  originY: number;
}

export const AURA_ARMA: Readonly<Record<number, EquipLightFrames>> = {
  1: { frames: 263, width: 172, height: 172, originX: 86.05, originY: 86.05 },
  2: { frames: 171, width: 189, height: 189, originX: 95, originY: 94.45 },
  3: { frames: 231, width: 192, height: 192, originX: 96.05, originY: 96.05 },
};

export const LUZ_PES: Readonly<Record<number, EquipLightFrames>> = {
  1: { frames: 31, width: 81, height: 73, originX: 41.35, originY: 46 },
  2: { frames: 31, width: 92, height: 66, originX: 46.5, originY: 43.95 },
  3: { frames: 31, width: 92, height: 69, originX: 49.6, originY: 44 },
};
